export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/75861996d859887085cdcc4cc2045b61.jpg"
          alt="Fletcher & Cooley Commercial Construction"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950/85 via-stone-900/70 to-stone-900/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-950/60 via-transparent to-stone-950/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-32 pb-24 w-full">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-px bg-amber-500" />
            <span className="text-amber-400 text-xs font-semibold tracking-[0.2em] uppercase">
              Henry County, GA &amp; Metro Atlanta
            </span>
          </div>

          {/* Headline */}
          <h1
            className="text-white font-bold leading-[1.05] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="block text-5xl md:text-7xl">Commercial</span>
            <span className="block text-5xl md:text-7xl text-amber-400">Construction</span>
            <span className="block text-4xl md:text-5xl font-normal italic mt-2">
              Built to Last. Delivered on Time.
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
            Fletcher &amp; Cooley delivers full-service commercial build-outs and tenant improvements for retail, office, medical, and multi-tenant properties across Henry County and Metro Atlanta — with licensed expertise, structured timelines, and zero surprises.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="#contact"
              className="whitespace-nowrap bg-amber-700 hover:bg-amber-600 text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-300 text-center cursor-pointer"
            >
              Request a Consultation
            </a>
            <a
              href="tel:6783948805"
              className="whitespace-nowrap border-2 border-white/60 hover:border-white text-white font-semibold text-base px-8 py-4 rounded-full transition-all duration-300 text-center flex items-center justify-center gap-2 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg" />
              </span>
              (678) 394-8805
            </a>
          </div>

          {/* Trust microcopy */}
          <div className="flex flex-wrap items-center gap-6">
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-check-line text-amber-400 text-base" />
              </span>
              <span className="text-white/70 text-sm">Licensed &amp; Insured in Georgia</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-amber-400 text-base" />
              </span>
              <span className="text-white/70 text-sm">5-Star Rated on Google</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-amber-400 text-base" />
              </span>
              <span className="text-white/70 text-sm">Stockbridge, GA — Locally Operated</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 text-base" />
        </span>
      </div>
    </section>
  );
}
